(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("pisco", [], factory);else if (typeof exports === 'object') exports["pisco"] = factory();else root["pisco"] = factory();
})(this, function () {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          /******/configurable: false,
          /******/enumerable: true,
          /******/get: getter
          /******/
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "/";
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = 6);
    /******/
  }
  /************************************************************************/
  /******/([( /* 0 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    var configs = {
      ENDPOINT: Object({
        "NODE_ENV": "production",
        "PUBLIC_URL": "",
        "API_SERVER": undefined
      }).REACT_APP_API_SERVER ? '' + Object({
        "NODE_ENV": "production",
        "PUBLIC_URL": "",
        "API_SERVER": undefined
      }).REACT_APP_API_SERVER : 'https://dev.pubninja.com',
      MAX_FILE_SIZE: 100,
      // max allowed file size 100 MB
      ELASTIC_RESULTS_PER_PAGE: 30,
      SEARCH_SOURCE: {
        'getty': 'GETTY',
        'elastic': 'ELASTIC'
      },
      IMAGE_SOURCE: {
        'getty': 'GETTY',
        'local': 'LOCAL'
      },
      SORTING_METHODS: {
        'best_match': 'By Relevance',
        'newest': 'By Date',
        'most_popular': 'By Popularity'
      },
      PISCO_IMAGE_S3_HOST: {
        'PROD': 'https://pisco-bucket.s3.amazonaws.com',
        'DEV': 'https://pisco-image-bucket.s3.amazonaws.com'
      },
      MEAWW_IMAGE_CDN_HOST: {
        'PROD': '//pisco.meaww.com',
        'DEV': '//disco.meaww.com'
      }
    }; /* harmony default export */
    __webpack_exports__["a"] = configs;

    /***/
  }), ( /* 1 */
  /***/function (module, exports) {
    module.exports = require("react");

    /***/
  }), ( /* 2 */
  /***/function (module, exports) {
    module.exports = require("gestalt");

    /***/
  }), ( /* 3 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* unused harmony export isValidSource */
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "c", function () {
      return getImageDimensionsPromise;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "d", function () {
      return getVideoDimensionsPromise;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "e", function () {
      return hasImageLoaded;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return getImageBinarySrcPromise;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return getCDNURL;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "g", function () {
      return isVideo;
    });
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "f", function () {
      return isImage;
    });
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__configs__ = __webpack_require__(0);
    // const videoMime = [
    //   'video/3gpp',
    //   'video/mp4',
    //   'video/mpeg',
    //   'video/ogg',
    //   'video/quicktime',
    //   'video/webm',
    //   'video/x-m4v',
    //   'video/ms-asf',
    //   'video/x-ms-wmv',
    //   'video/x-msvideo',
    // ]
    // const imageMime = [
    //   'image/bmp',
    //   'image/cis-cod',
    //   'image/gif',
    //   'image/ief',
    //   'image/jpeg',
    //   'image/pipeg',
    //   'image/svg+xml',
    //   'image/tiff',
    //   'image/x-cmu-raster',
    //   'image/x-cmx',
    //   'image/x-icon',
    //   'image/x-portable-anymap',
    //   'image/x-portable-bitmap',
    //   'image/x-portable-graymap',
    //   'image/x-portable-pixmap',
    //   'image/x-rgb',
    //   'image/x-xbitmap',
    //   'image/x-xpixmap',
    //   'image/x-xwindowdump',
    // ]
    var isValidSource = function isValidSource(source) {
      return Object.values(__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE).indexOf(source) !== -1;
    };
    var getImageDimensionsPromise = function getImageDimensionsPromise(src) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var height = img.height,
            width = img.width;
          return resolve({
            height: height,
            width: width
          });
        };
        img.src = src;
      });
    };
    var getVideoDimensionsPromise = function getVideoDimensionsPromise(src) {
      return new Promise(function (resolve, reject) {
        var video = document.createElement("video");
        video.autoplay = true;
        video.oncanplay = function () {
          var dim = {
            width: this.offsetWidth,
            height: this.offsetHeight
          };
          this.remove();
          return resolve(dim);
        };
        video.onerror = function () {
          this.remove();
          return reject("Media Type Not Supported.(Supported Format are: mp4, m4v, WebM)");
        };
        document.body.appendChild(video);
        video.src = src;
      });
    };
    var hasImageLoaded = function hasImageLoaded(src) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          if (!img.complete || !img.naturalWidth || !img.naturalHeight) {
            return reject(new Error('Image not loaded completely'));
          } else {
            return resolve();
          }
        };
        img.onerror = function (err) {
          console.error(img);
          return reject(err);
        };
        img.src = src;
      });
    };
    var getImageBinarySrcPromise = function getImageBinarySrcPromise(imageFile) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.readAsDataURL(imageFile);
      });
    };
    var getCDNURL = function getCDNURL(s3Url) {
      var PISCO_IMAGE_S3_HOST = __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].PISCO_IMAGE_S3_HOST,
        MEAWW_IMAGE_CDN_HOST = __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].MEAWW_IMAGE_CDN_HOST;
      return s3Url.replace(PISCO_IMAGE_S3_HOST.PROD, MEAWW_IMAGE_CDN_HOST.PROD).replace(PISCO_IMAGE_S3_HOST.DEV, MEAWW_IMAGE_CDN_HOST.DEV);
    };
    var isVideo = function isVideo(file) {
      return file.type.startsWith('video');
    };
    var isImage = function isImage(file) {
      return file.type.startsWith('image');
    };

    /***/
  }), ( /* 4 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    var DEBUG = false; // Note that all dispatch calls will behave synchronously relative to each other in context of the state
    // eg:
    // making following two calls in order
    // STATE = {counter: 0}
    // this.dispatch(increment());
    // this.dispatch(increment());
    // the next action dispatche will always recieve STATE = {coounter: 2}
    /* harmony default export */
    __webpack_exports__["a"] = function (reducerFunction, callback) {
      var _this = this;
      if (DEBUG) {
        console.log('------ DISPATCH ------');
        console.log('component: ', this.constructor.name);
        console.log('action:', reducerFunction.name, reducerFunction);
        console.log('----------------------');
      }
      if (!callback) {
        // if callback is not provided
        // return promise, just in case someone needs it
        return new Promise(function (resolve) {
          _this.setState(reducerFunction, resolve);
        });
      }
      this.setState(reducerFunction, callback);
    };
    ;

    /***/
  }), ( /* 5 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__configs__ = __webpack_require__(0);
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }
      return obj;
    }
    var mapSourcesToValue = function mapSourcesToValue(value) {
      return Object.values(__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE).reduce(function (res, src) {
        return Object.assign({}, res, _defineProperty({}, src, value));
      }, {});
    };
    var sidebarMapping = {
      "Both": {
        'ELASTIC': ['Image', 'Video'],
        'GETTY': ['Image']
      },
      "Image": {
        'ELASTIC': ['Image'],
        'GETTY': ['Image']
      },
      "Video": {
        'ELASTIC': ['Videos'],
        'GETTY': ['Image']
      }
    };
    var reducer = {
      getInitialState: function getInitialState() {
        return {
          // empty search results skeleton with placeholders for each source
          isLoadingTags: false,
          searchTerm: '',
          searchResults: mapSourcesToValue([]),
          currentPage: mapSourcesToValue(0),
          activeSideBar: ['Image'],
          activeType: 'Image',
          searchQuery: '',
          selectedImage: {},
          loading: false,
          showModal: false,
          showEmbedDialog: false,
          activeGallery: __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic,
          previewIsOpen: false,
          selectedPreview: 0,
          hasMoreGetty: true,
          hasMoreElastic: true,
          settingsIsOpen: false,
          searchOnSettings: mapSourcesToValue(true),
          sortBy: Object.keys(__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SORTING_METHODS)[0]
        };
      },
      clearSearchResults: function clearSearchResults() {
        return {
          searchResults: Object.values(__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE).reduce(function (res, src) {
            return Object.assign({}, res, _defineProperty({}, src, []));
          }, {}),
          currentPage: Object.values(__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE).reduce(function (res, src) {
            return Object.assign({}, res, _defineProperty({}, src, 0));
          }, {})
        };
      },
      toggleHasMore: function toggleHasMore(source, hasMore) {
        return function (state) {
          var key = source === __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic ? 'hasMoreElastic' : 'hasMoreGetty';
          return typeof hasMore === 'undefined' ? _defineProperty({}, key, !state[key]) : _defineProperty({}, key, hasMore);
        };
      },
      toggleSettings: function toggleSettings(show) {
        return function (state) {
          return typeof show === 'undefined' ? {
            settingsIsOpen: !state.settingsIsOpen
          } : {
            settingsIsOpen: show
          };
        };
      },
      toggleLoading: function toggleLoading(isLoading) {
        return function (state) {
          return typeof isLoading === 'undefined' ? {
            loading: !state.loading
          } : {
            loading: isLoading
          };
        };
      },
      toggleLoadingTags: function toggleLoadingTags(isLoadingTags) {
        return function (state) {
          return typeof isLoadingTags === 'undefined' ? {
            isLoadingTags: !state.isLoadingTags
          } : {
            isLoadingTags: isLoadingTags
          };
        };
      },
      togglePreview: function togglePreview(show) {
        return function (state) {
          return typeof show === 'undefined' ? {
            previewIsOpen: !state.previewIsOpen
          } : {
            previewIsOpen: show
          };
        };
      },
      toggleModal: function toggleModal(show) {
        return function (state) {
          return typeof show === 'undefined' ? {
            showModal: !state.showModal
          } : {
            showModal: show
          };
        };
      },
      toggleEmbedDialog: function toggleEmbedDialog(show) {
        return function (state) {
          return typeof show === 'undefined' ? {
            showEmbedDialog: !state.showEmbedDialog
          } : {
            showEmbedDialog: show
          };
        };
      },
      toggleSearchOn: function toggleSearchOn(source, isOn) {
        return function (state) {
          return {
            searchOnSettings: Object.assign({}, state.searchOnSettings, _defineProperty({}, source, typeof isOn === 'undefined' ? !state.searchOnSettings[source] : isOn))
          };
        };
      },
      filterElasticResults: function filterElasticResults(uuid) {
        return function (state) {
          var newState = {
            searchResults: Object.assign({}, state.searchResults, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic, [].concat(_toConsumableArray(state.searchResults[__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic].filter(function (item) {
              return item.uuid != uuid;
            })))))
          };
          return newState;
        };
      },
      setSearchTerm: function setSearchTerm(value) {
        return function () {
          return {
            searchTerm: value
          };
        };
      },
      selectSortingMethod: function selectSortingMethod(method) {
        return function () {
          return {
            sortBy: method
          };
        };
      },
      updateImageResults: function updateImageResults(source, results) {
        return function (state) {
          var newState = {
            searchResults: Object.assign({}, state.searchResults, _defineProperty({}, source, [].concat(_toConsumableArray(state.searchResults[source]), _toConsumableArray(results))))
          };
          return newState;
        };
      },
      setSearchQuery: function setSearchQuery(qry) {
        return function () {
          return {
            searchQuery: qry
          };
        };
      },
      selectActiveSideBar: function selectActiveSideBar(type, source) {
        return function () {
          return {
            activeSideBar: sidebarMapping[type][source]
          };
        };
      },
      selectActiveType: function selectActiveType(type) {
        return function () {
          return {
            activeType: type
          };
        };
      },
      selectGallery: function selectGallery(name) {
        return function () {
          return {
            activeGallery: name
          };
        };
      },
      selectImage: function selectImage(img) {
        return function () {
          return {
            selectedImage: img
          };
        };
      },
      updateSelectedImage: function updateSelectedImage(updates) {
        return function (state) {
          return {
            selectedImage: Object.assign({}, state.selectedImage, updates)
          };
        };
      },
      previewImage: function previewImage(selectedImg) {
        return function (state) {
          return {
            selectedPreview: state.searchResults[state.activeGallery].findIndex(function (img) {
              return img.id === selectedImg.id;
            })
          };
        };
      },
      moveSavedGettyImage: function moveSavedGettyImage(savedImage) {
        return function (state) {
          var _searchResults;
          var gettyResults = state.searchResults[__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.getty];
          var elasticResults = state.searchResults[__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic];
          var existingGettyImg = gettyResults.find(function (img) {
            return img.id === savedImage.id;
          });
          var updatedImage = Object.assign({}, existingGettyImg, savedImage, {
            searchSource: __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic
          });
          var results = {
            searchResults: (_searchResults = {}, _defineProperty(_searchResults, __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.getty, gettyResults.filter(function (img) {
              return img !== existingGettyImg;
            })), _defineProperty(_searchResults, __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic, [updatedImage].concat(_toConsumableArray(elasticResults))), _searchResults)
          };
          return results;
        };
      },
      moveSavedLocalImage: function moveSavedLocalImage(savedImage) {
        return function (state) {
          return {
            searchResults: Object.assign({}, state.searchResults, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic, [Object.assign({}, state.selectedImage, savedImage, {
              searchSource: __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic
            })].concat(_toConsumableArray(state.searchResults[__WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic]))))
          };
        };
      },
      paginate: function paginate(searchSource) {
        return function (state) {
          return {
            currentPage: Object.assign({}, state.currentPage, _defineProperty({}, searchSource, state.currentPage[searchSource] + 1))
          };
        };
      }
    }; /* harmony default export */
    __webpack_exports__["a"] = reducer;

    /***/
  }), ( /* 6 */
  /***/function (module, exports, __webpack_require__) {
    __webpack_require__(7);
    module.exports = __webpack_require__(12);

    /***/
  }), ( /* 7 */
  /***/function (module, exports, __webpack_require__) {
    "use strict";

    if (typeof Promise === 'undefined') {
      // Rejection tracking prevents a common issue where React gets into an
      // inconsistent state due to an error, but it gets swallowed by a Promise,
      // and the user has no idea what causes React's erratic future behavior.
      __webpack_require__(8).enable();
      window.Promise = __webpack_require__(9);
    }

    // fetch() polyfill for making API calls.
    __webpack_require__(10);

    // Object.assign() is commonly used with React.
    // It will use the native implementation if it's present and isn't buggy.
    Object.assign = __webpack_require__(11);

    // In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
    // We don't polyfill it in the browser--this is user's responsibility.
    if (false) {
      require('raf').polyfill(global);
    }

    /***/
  }), ( /* 8 */
  /***/function (module, exports) {
    module.exports = require("promise/lib/rejection-tracking");

    /***/
  }), ( /* 9 */
  /***/function (module, exports) {
    module.exports = require("promise/lib/es6-extensions.js");

    /***/
  }), ( /* 10 */
  /***/function (module, exports) {
    module.exports = require("whatwg-fetch");

    /***/
  }), ( /* 11 */
  /***/function (module, exports) {
    module.exports = require("object-assign");

    /***/
  }), ( /* 12 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    Object.defineProperty(__webpack_exports__, "__esModule", {
      value: true
    });
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt_dist_gestalt_css__ = __webpack_require__(13);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt_dist_gestalt_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gestalt_dist_gestalt_css__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__styles_styles_css__ = __webpack_require__(14);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__styles_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__styles_styles_css__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3__configs__ = __webpack_require__(0);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_5__components_Preview_jsx__ = __webpack_require__(15);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_6__utils_dispatch_js__ = __webpack_require__(4);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_7__components_SearchBar_jsx__ = __webpack_require__(17);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_8__components_SearchResults_jsx__ = __webpack_require__(18);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_9__components_SaveDialog_jsx__ = __webpack_require__(22);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_10__components_EmbedDialog_jsx__ = __webpack_require__(25);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_11__components_Settings_jsx__ = __webpack_require__(26);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_12__utils_api__ = __webpack_require__(28);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_13__App_reducer__ = __webpack_require__(5);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_14__utils_parseLocalUpload__ = __webpack_require__(34);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_15__utils_helpers__ = __webpack_require__(3);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(35);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      } else {
        return Array.from(arr);
      }
    }
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var App = function (_Component) {
      _inherits(App, _Component);
      function App(props) {
        _classCallCheck(this, App);
        var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
        _this._fetchAssetArticles = function (uuid) {
          return _this.API.media.details(_this.props.injectQuery, uuid).then(function (response) {
            return response.body;
          }).catch(function (error) {
            return console.log;
          });
        };
        _this._deleteMedia = function (uuid) {
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleEmbedDialog(false));
          _this.API.media.delete(uuid).then(function (response) {
            return response.body;
          }).then(function (response) {
            alert('Media Deleted Successfully');
            _this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].filterElasticResults(uuid));
          }).catch(function (error) {
            return alert('Unable to Delete Media.');
          });
        };
        _this.onMediaTypeChange = function (type) {
          _this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectActiveType(type), function (state) {
            _this._onSearch(_this.state.searchQuery, type);
          });
        };
        _this.API = Object(__WEBPACK_IMPORTED_MODULE_12__utils_api__["a" /* default */])(props.endpoint, props.headers);
        _this.state = __WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].getInitialState(); // map state to dispatcher
        _this.dispatch = __WEBPACK_IMPORTED_MODULE_6__utils_dispatch_js__["a" /* default */].bind(_this);
        _this._onSearch = _this._onSearch.bind(_this);
        _this._onScroll = _this._onScroll.bind(_this);
        _this._onUpload = _this._onUpload.bind(_this);
        _this._selectImage = _this._selectImage.bind(_this);
        _this._selectGallery = _this._selectGallery.bind(_this);
        _this._setActiveSideBar = _this._setActiveSideBar.bind(_this);
        _this._updateSelectedImage = _this._updateSelectedImage.bind(_this);
        _this._save = _this._save.bind(_this);
        _this._downloadImage = _this._downloadImage.bind(_this);
        _this._embedImage = _this._embedImage.bind(_this);
        _this._showPreview = _this._showPreview.bind(_this);
        _this._closePreview = _this._closePreview.bind(_this);
        _this._onSortingChange = _this._onSortingChange.bind(_this);
        _this._manageGettySearch = _this._manageGettySearch.bind(_this);
        return _this;
      }
      _createClass(App, [{
        key: '_showPreview',
        value: function _showPreview(img) {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].togglePreview());
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].previewImage(img));
        }
      }, {
        key: '_closePreview',
        value: function _closePreview() {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].togglePreview());
        }
      }, {
        key: '_downloadImage',
        value: function _downloadImage() {
          var img = this.state.selectedImage;
          var link = document.createElement('a');
          link.href = img.cdn || Object(__WEBPACK_IMPORTED_MODULE_15__utils_helpers__["a" /* getCDNURL */])(img.s3Url);
          link.setAttribute('target', '_blank');
          if (img.filename) {
            link.download = img.filename;
          }
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleEmbedDialog(false));
        }
      }, {
        key: '_embedImage',
        value: function _embedImage(img) {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleEmbedDialog(false));
          this.props.onEmbed(img);
        }
      }, {
        key: '_onSearch',
        value: function _onSearch(qry) {
          var _this2 = this;
          var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var sortBy = !qry || qry === '*' ? 'newest' : this.state.sortBy;
          if (!qry) {
            qry = '*';
          }
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(true));
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].setSearchQuery(qry));
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].clearSearchResults);
          var resultsPromise = []; // Assuming this always finishes up before Getty API
          if (this.state.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic] && this.state.activeGallery == __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic) {
            var gettyResultsPromise = this.API.search.elastic(this.props.domain, type || this.state.activeType, qry, 0, sortBy, this.props.injectQuery).then(function (results) {
              if (results.length < __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].ELASTIC_RESULTS_PER_PAGE) {
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, false));
              } else {
                _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, true));
              } // return last dispatch promise to excute finally
              return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].updateImageResults(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, results));
            }).catch(function (err) {
              console.error(err);
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, false));
            });
            resultsPromise.push(gettyResultsPromise);
          }
          if (this.state.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty] && this.state.activeGallery == __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty && this.props.type !== 'Video') {
            var _gettyResultsPromise = this.API.search.getty(qry, 1, sortBy, this.props.injectQuery).then(function (results) {
              var elasticResults = _this2.state.searchResults[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic];
              var elasticImgIds = elasticResults.map(function (elasticImg) {
                return elasticImg.id;
              }); // exclude elastic search results from getty search results
              var gettyResults = results.filter(function (gettyImg) {
                return elasticImgIds.indexOf(gettyImg.id) === -1;
              });
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].updateImageResults(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, gettyResults)); // return last dispatch promise to excute finally
              return _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].paginate(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty));
            }).catch(function (err) {
              console.error(err);
              _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, false));
            });
            resultsPromise.push(_gettyResultsPromise);
          } // when all requests have completed or atleast one has failed, set loading flag to FALSE
          Promise.all(resultsPromise).finally(function () {
            _this2.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
          });
        }
      }, {
        key: '_onScroll',
        value: function _onScroll() {
          var _this3 = this;
          var sortBy = this.state.searchQuery.trim() === '*' ? 'newest' : this.state.sortBy;
          var nextPage = void 0;
          if (!this.state.loading) {
            switch (this.state.activeGallery) {
              case __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty:
                // break out, if no more results available or search on getty if off
                if (!this.state.hasMoreGetty || !this.state.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty] || this.props.type === 'Video') {
                  break;
                }
                nextPage = this.state.currentPage[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty] + 1;
                this.API.search.getty(this.state.searchQuery, nextPage, sortBy, this.props.injectQuery).then(function (results) {
                  var elasticResults = _this3.state.searchResults[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic];
                  var elasticImgIds = elasticResults.map(function (elasticImg) {
                    return elasticImg.id;
                  }); // exclude elastic search results from getty search results
                  var gettyResults = results.filter(function (gettyImg) {
                    return elasticImgIds.indexOf(gettyImg.id) === -1;
                  });
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].updateImageResults(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, gettyResults));
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].paginate(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty));
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
                  if (!gettyResults.length) {
                    _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, false));
                  }
                }).catch(function (err) {
                  console.error(err);
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, false));
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
                });
                break;
              case __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic:
                // break out, if no more results available or search on getty if off
                if (!this.state.hasMoreElastic || !this.state.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic]) {
                  break;
                }
                nextPage = this.state.searchResults[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic].length;
                this.API.search.elastic(this.props.domain, this.state.activeType, this.state.searchQuery, nextPage, sortBy, this.props.injectQuery).then(function (results) {
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].updateImageResults(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, results));
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
                  if (results.length < __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].ELASTIC_RESULTS_PER_PAGE) {
                    _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, false));
                  }
                }).catch(function (err) {
                  console.error(err);
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, false));
                  _this3.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
                });
                break;
              default: // do nothing, chill
            }
          }
        }
      }, {
        key: '_selectGallery',
        value: function _selectGallery(galleryName) {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectGallery(galleryName));
        }
      }, {
        key: '_setActiveSideBar',
        value: function _setActiveSideBar(type, source) {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectActiveSideBar(type, source));
        }
      }, {
        key: '_selectImage',
        value: function _selectImage(source, id) {
          var _this4 = this;
          return function () {
            var selectedImage = _this4.state.searchResults[source].find(function (img) {
              return img.id === id;
            }) || {};
            _this4.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectImage(selectedImage));
            if (selectedImage.searchSource === __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic) {
              _this4.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleEmbedDialog(true));
            } else {
              _this4.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleModal(true)); // asynchronously fetch image tags from google vision api
              _this4.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoadingTags(true));
              _this4.API.getImageTags(selectedImage.previewUrl, _this4.props.injectQuery).then(function (labels) {
                var tags = [].concat(_toConsumableArray(labels.content), _toConsumableArray(labels.web));
                _this4._updateSelectedImage({
                  tags: tags
                });
                _this4.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoadingTags(false));
              }).catch(function (err) {
                console.error(err);
              });
            }
          };
        }
      }, {
        key: '_onUpload',
        value: function _onUpload(file) {
          var _this5 = this; // limit upload file size
          var fileSizeInMb = file.size / 1024 / 1024;
          if (fileSizeInMb > __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].MAX_FILE_SIZE) {
            alert('Selected file size is ' + Math.round(fileSizeInMb) + ' MB. \nMax allowed file size is ' + __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].MAX_FILE_SIZE + ' MB.');
            return;
          } // if file size is in limits, proceed...
          Object(__WEBPACK_IMPORTED_MODULE_14__utils_parseLocalUpload__["a" /* default */])(file, this.props.type).then(function (selectedImage) {
            if (selectedImage.type === 'Video') {
              selectedImage.title = "";
            }
            _this5.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectImage(selectedImage));
            _this5.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleModal(true));
            var a = file.name.split('.');
            if (a.length <= 1) return alert('Invalid Media Extention');
            var name = Object(__WEBPACK_IMPORTED_MODULE_16_lodash__["kebabCase"])(a.slice(0, a.length - 1).join('.')) + '.' + a[a.length - 1];
            file = new File([file], name, {
              type: file.type
            });
            _this5.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoadingTags(true));
            _this5.API.save.preSave(file, _this5.props.injectQuery).then(function (response) {
              var labels = response.labels;
              var tags = [].concat(_toConsumableArray(labels.content), _toConsumableArray(labels.web));
              _this5._updateSelectedImage({
                tags: tags
              });
              _this5.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoadingTags(false));
            });
          }).catch(function (err) {
            _this5.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleModal(false));
            alert("Unable to upload Media");
            console.log('Failed to Fetch upload image\'s dimensions.');
            console.error(err);
          });
        }
      }, {
        key: '_updateSelectedImage',
        value: function _updateSelectedImage(updates) {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].updateSelectedImage(updates));
        }
      }, {
        key: '_save',
        value: function _save() {
          var _this6 = this;
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(true)); // add 'searchQuery' value to the image data for ES index
          var img = Object.assign({}, this.state.selectedImage, {
            searchQuery: this.state.searchQuery
          });
          var savePromise = void 0;
          if (img.imageSource === __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].IMAGE_SOURCE.getty) {
            savePromise = this.API.save.getty(this.props.domain, img, this.props.injectQuery).then(function (savedImage) {
              _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].moveSavedGettyImage(savedImage));
            });
          } else {
            // if image source is local upload
            // omitting some values, because image was already uploaded in preSave stage
            delete img.src;
            delete img.thumbUrl;
            delete img.previewUrl;
            var postObj = Object.assign({}, img, {
              type: img.type
            });
            var nameArr = postObj.filename.split('.');
            if (nameArr.length <= 1) return alert('Invalid Media Extention');
            postObj.filename = Object(__WEBPACK_IMPORTED_MODULE_16_lodash__["kebabCase"])(nameArr.slice(0, nameArr.length - 1).join('.')) + '.' + nameArr[nameArr.length - 1];
            savePromise = this.API.save.local(this.props.domain, new Blob(), postObj, this.props.injectQuery).then(function (savedImage) {
              _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].moveSavedLocalImage(savedImage));
            });
          }
          savePromise.then(function () {
            _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
            _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleModal(false));
            _this6._selectGallery(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic); // not concerned about more results as we are not searching for anything
            _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleHasMore(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic, false));
          }).catch(function (err) {
            console.error(err);
            _this6.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleLoading(false));
          });
        }
      }, {
        key: '_onSortingChange',
        value: function _onSortingChange(sortMethod) {
          var _this7 = this;
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectSortingMethod(sortMethod), function () {
            // start new search with updated sorting, after state is set successfully
            _this7._onSearch(_this7.state.searchQuery);
          });
        }
      }, {
        key: '_manageGettySearch',
        value: function _manageGettySearch() {
          if (this.props.disableGetty) {
            this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleSearchOn(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty, false));
          }
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
          if (prevProps.disableGetty !== this.props.disableGetty) {
            this._manageGettySearch();
          }
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectActiveSideBar(this.props.type, 'ELASTIC'));
          this.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].selectActiveType('Image'));
          this._onSearch('', "Image");
          this._manageGettySearch();
        }
      }, {
        key: 'renderActiveSideBar',
        value: function renderActiveSideBar() {
          var _this8 = this;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, this.state.activeSideBar.map(function (item) {
            var color = item == _this8.state.activeType ? 'red' : 'midnight';
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"], {
              key: item,
              dangerouslySetInlineStyle: {
                __style: {
                  cursor: 'pointer'
                }
              }
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Text"], {
              color: color,
              size: 'md',
              bold: true
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', {
              className: 'media-type-selector',
              style: {
                margin: '10px 0'
              },
              onClick: _this8.onMediaTypeChange.bind(_this8, item)
            }, item)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Divider"], null));
          }));
        }
      }, {
        key: 'render',
        value: function render() {
          var _this9 = this;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            id: 'pisco-app-container'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Settings_jsx__["a" /* default */], {
            isOpen: this.state.settingsIsOpen,
            onStateChange: function onStateChange(_ref) {
              var isOpen = _ref.isOpen;
              _this9.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleSettings(isOpen));
            },
            toggleSearchOn: function toggleSearchOn(source) {
              return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleSearchOn(source));
            },
            searchOnSettings: this.state.searchOnSettings,
            disableGetty: this.props.disableGetty,
            sortBy: this.state.sortBy,
            onSortingChange: this._onSortingChange
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            id: 'pisco-app-wrapper'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"], {
            color: 'white'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_SearchBar_jsx__["a" /* default */], {
            onSearch: this._onSearch,
            onUpload: this._onUpload,
            loading: this.state.loading,
            openSettings: function openSettings() {
              _this9.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleSettings(true));
            },
            type: this.props.type
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"] // alignItems="center"
          , {
            direction: 'row',
            display: 'flex',
            marginStart: 1,
            marginEnd: 1,
            position: 'relative'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: 'active-sidebar'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"], {
            padding: 1,
            justifyContent: 'center'
          }, this.renderActiveSideBar())), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: 'search-results-container'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_gestalt__["Box"], {
            color: 'white'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_SearchResults_jsx__["a" /* default */], {
            results: this.state.searchResults,
            selectImage: this._selectImage,
            onScroll: this._onScroll,
            type: this.props.type,
            showModal: this.state.showModal || this.state.showEmbedDialog // required to toggle sticky componetn's z-index bug in SearchResults
            ,
            loading: this.state.loading,
            activeGallery: this.state.activeGallery,
            selectGallery: this._selectGallery,
            setActiveSideBar: this._setActiveSideBar,
            searchOnSettings: this.state.searchOnSettings,
            showPreview: this._showPreview,
            hasMoreElastic: this.state.hasMoreElastic,
            hasMoreGetty: this.state.hasMoreGetty,
            activeSideBar: this.state.activeSideBar,
            activeType: this.state.activeType,
            onSearch: this.onSearch,
            mediaTypeChange: this.onMediaTypeChange
          })))), this.state.showModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_SaveDialog_jsx__["a" /* default */], {
            id: 'save-dialog',
            img: this.state.selectedImage,
            hideModal: function hideModal() {
              _this9.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleModal(false));
            } // dialog has only been passed handlers to hide itself, not to show
            ,
            updateSelectedImage: this._updateSelectedImage,
            save: this._save,
            loading: this.state.loading,
            isLoadingTags: this.state.isLoadingTags
          }), this.state.showEmbedDialog && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_EmbedDialog_jsx__["a" /* default */], {
            mode: this.props.mode || 'embed',
            img: this.state.selectedImage,
            hideModal: function hideModal() {
              return _this9.dispatch(__WEBPACK_IMPORTED_MODULE_13__App_reducer__["a" /* default */].toggleEmbedDialog(false));
            },
            fetchAssetArticles: this._fetchAssetArticles,
            downloadImage: this._downloadImage,
            embedImage: this._embedImage,
            deleteMedia: this._deleteMedia
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Preview_jsx__["a" /* default */], {
            images: this.state.searchResults[this.state.activeGallery],
            currentImage: this.state.selectedPreview,
            isOpen: this.state.previewIsOpen,
            onClose: this._closePreview,
            onStateChange: function onStateChange(state) {
              console.log({
                state: state
              });
            }
          }))));
        }
      }]);
      return App;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); /* harmony default export */
    __webpack_exports__["default"] = App;

    /***/
  }), ( /* 13 */
  /***/function (module, exports) {

    // removed by extract-text-webpack-plugin

    /***/}), ( /* 14 */
  /***/function (module, exports) {

    // removed by extract-text-webpack-plugin

    /***/}), ( /* 15 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_images_videos__ = __webpack_require__(16);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_images_videos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_images_videos__);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var Preview = function (_React$Component) {
      _inherits(Preview, _React$Component);
      function Preview() {
        _classCallCheck(this, Preview);
        var _this = _possibleConstructorReturn(this, (Preview.__proto__ || Object.getPrototypeOf(Preview)).call(this));
        _this.state = {
          currentImage: 0
        };
        _this._gotoNext = _this._gotoNext.bind(_this);
        _this._gotoPrevious = _this._gotoPrevious.bind(_this);
        return _this;
      }
      _createClass(Preview, [{
        key: '_gotoPrevious',
        value: function _gotoPrevious() {
          this.setState({
            currentImage: this.state.currentImage - 1
          });
        }
      }, {
        key: '_gotoNext',
        value: function _gotoNext() {
          this.setState({
            currentImage: this.state.currentImage + 1
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps.currentImage !== this.props.currentImage) {
            this.setState({
              currentImage: nextProps.currentImage
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_images_videos___default.a, {
            currentImage: this.state.currentImage,
            images: this.props.images,
            isOpen: this.props.isOpen,
            onClose: this.props.onClose,
            onClickPrev: this._gotoPrevious,
            onClickNext: this._gotoNext,
            showImageCount: true,
            showCloseButton: true,
            backdropClosesModal: true,
            width: '90vw'
          });
        }
      }]);
      return Preview;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); /* harmony default export */
    __webpack_exports__["a"] = Preview;

    /***/
  }), ( /* 16 */
  /***/function (module, exports) {
    module.exports = require("react-images-videos");

    /***/
  }), ( /* 17 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gestalt__);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var SearchBar = function (_React$Component) {
      _inherits(SearchBar, _React$Component);
      function SearchBar(props) {
        _classCallCheck(this, SearchBar);
        var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));
        _this.state = {
          value: ''
        };
        _this._onSearch = _this._onSearch.bind(_this);
        _this._onUpload = _this._onUpload.bind(_this);
        _this._attachOnPressEnter = _this._attachOnPressEnter.bind(_this);
        return _this;
      }
      _createClass(SearchBar, [{
        key: '_onSearch',
        value: function _onSearch() {
          this.props.onSearch(this.state.value);
        }
      }, {
        key: '_onUpload',
        value: function _onUpload(e) {
          var file = e.target.files[0];
          var uploadType = file && file.type.split("/")[0];
          var extension = file && file.type.split("/")[1];
          if (uploadType == 'image' && extension == 'webp') {
            e.target.value = null;
            alert('Webp images are not allowed, as they are not supported in Safari browser.');
            return;
          }
          e.target.value = null;
          this.props.onUpload(file);
        }
      }, {
        key: '_attachOnPressEnter',
        value: function _attachOnPressEnter() {
          var _this2 = this; // submit search query on pressing 'Enter'
          document.querySelector('#search-field').addEventListener('keypress', function (e) {
            if (e.which === 13) {
              _this2._onSearch();
            }
          });
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this._attachOnPressEnter();
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;
          var acceptAttr = !this.props.type || this.props.type === 'Both' ? '.png, .jpg, .jpeg, .gif, .m4v, .mp4, .webm' // assuming both are allowed if nothing is provided
          : this.props.type === 'Video' ? '.m4v, .mp4, .webm' : '.png, .jpg, .jpeg, .gif'; // assuming only images if any value other than 'Video' is provided
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            color: 'white',
            shape: 'rounded',
            padding: 3,
            display: 'flex',
            direction: 'row',
            alignItems: 'center'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            padding: 3
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["IconButton"], {
            icon: 'menu',
            iconColor: 'red',
            accessibilityLabel: 'Select Source',
            onClick: function onClick() {
              _this3.props.openSettings();
            }
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            flex: 'grow',
            paddingX: 2
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["SearchField"], {
            accessibilityLabel: 'Image Lookup',
            id: 'search-field',
            placeholder: 'Search',
            onChange: function onChange(_ref) {
              var value = _ref.value;
              return _this3.setState({
                value: value
              });
            },
            value: this.state.value
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            paddingX: 2
          }, this.props.loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Spinner"], {
            show: this.props.loading,
            accessibilityLabel: 'search in progress'
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["IconButton"], {
            accessibilityLabel: 'Go',
            icon: 'play',
            size: 'md',
            iconColor: 'red',
            onClick: this._onSearch
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            paddingX: 2
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["IconButton"], {
            accessibilityLabel: 'Upload',
            icon: 'share',
            iconColor: 'red',
            size: 'md',
            onClick: function onClick() {
              document.querySelector('#pisco-fileUploader').click();
            }
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            type: 'file',
            accept: acceptAttr,
            onChange: this._onUpload,
            id: 'pisco-fileUploader',
            style: {
              display: "none"
            }
          })));
        }
      }]);
      return SearchBar;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
    ; /* harmony default export */
    __webpack_exports__["a"] = SearchBar;

    /***/
  }), ( /* 18 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(0);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3__utils_dispatch__ = __webpack_require__(4);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4__Gallery_jsx__ = __webpack_require__(19);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_5__App_reducer__ = __webpack_require__(5);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    } // import Gallery from './GalleryGestalt.jsx';
    var searchSources = Object.values(__WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */].SEARCH_SOURCE);
    var getSearchSourcesText = function getSearchSourcesText(searchOnSettings, results) {
      return searchSources.map(function (source) {
        return '' + source + (searchOnSettings[source] ? ' ( ' + results[source].length + ' results)' : ' (SEARCH OFF)');
      });
    };
    var getTabsHeadings = function getTabsHeadings(searchOnSettings, results) {
      return searchSources.map(function (source, index) {
        return {
          "href": source,
          "text": searchOnSettings[source] ? source + "(" + results[source].length + ')' : source + ' Off'
        };
      });
    };
    var SearchResults = function (_React$Component) {
      _inherits(SearchResults, _React$Component);
      function SearchResults() {
        _classCallCheck(this, SearchResults);
        var _this = _possibleConstructorReturn(this, (SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call(this));
        _this.state = __WEBPACK_IMPORTED_MODULE_5__App_reducer__["a" /* default */].getInitialState();
        _this.dispatch = __WEBPACK_IMPORTED_MODULE_3__utils_dispatch__["a" /* default */].bind(_this);
        _this._onSourceChange = _this._onSourceChange.bind(_this);
        return _this;
      }
      _createClass(SearchResults, [{
        key: '_onSourceChange',
        value: function _onSourceChange(_ref) {
          var activeIndex = _ref.activeIndex;
          var source = searchSources[activeIndex];
          this.props.setActiveSideBar(this.props.type, source); // check if gallery source to activate is from one of the valid sources
          var isValidSource = typeof source === 'string' && searchSources.indexOf(source) !== -1;
          if (isValidSource) {
            this.props.selectGallery(source);
            this.props.mediaTypeChange('Image');
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Sticky"], {
            top: 0,
            dangerouslySetZIndex: {
              __zIndex: this.props.showModal ? 0 : 3
            }
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            column: 12
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
            className: 'segmented-control'
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["SegmentedControl"], {
            items: getSearchSourcesText(this.props.searchOnSettings, this.props.results),
            selectedItemIndex: searchSources.indexOf(this.props.activeGallery),
            onChange: this._onSourceChange
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Gallery_jsx__["a" /* default */], {
            source: this.props.activeGallery,
            images: this.props.results[this.props.activeGallery],
            selectImage: this.props.selectImage,
            onScroll: this.props.onScroll,
            showPreview: this.props.showPreview,
            hasMore: this.props.activeGallery === __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */].SEARCH_SOURCE.elastic ? this.props.hasMoreElastic : this.props.hasMoreGetty
          })))));
        }
      }]);
      return SearchResults;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); /* harmony default export */
    __webpack_exports__["a"] = SearchResults;

    /***/
  }), ( /* 19 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_masonry_component__ = __webpack_require__(20);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_masonry_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_masonry_component__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__ = __webpack_require__(21);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller__);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    var _get = function get(object, property, receiver) {
      if (object === null) object = Function.prototype;
      var desc = Object.getOwnPropertyDescriptor(object, property);
      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) {
          return undefined;
        } else {
          return get(parent, property, receiver);
        }
      } else if ("value" in desc) {
        return desc.value;
      } else {
        var getter = desc.get;
        if (getter === undefined) {
          return undefined;
        }
        return getter.call(receiver);
      }
    };
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    } // https://github.com/eiriklv/react-masonry-component
    var InfiniteScrollOnContainer = function (_InfiniteScroll) {
      _inherits(InfiniteScrollOnContainer, _InfiniteScroll);
      function InfiniteScrollOnContainer() {
        _classCallCheck(this, InfiniteScrollOnContainer);
        return _possibleConstructorReturn(this, (InfiniteScrollOnContainer.__proto__ || Object.getPrototypeOf(InfiniteScrollOnContainer)).apply(this, arguments));
      }
      _createClass(InfiniteScrollOnContainer, [{
        key: 'getParentElement',
        value: function getParentElement(el) {
          if (this.props.container) {
            return document.getElementById(this.props.container);
          }
          return _get(InfiniteScrollOnContainer.prototype.__proto__ || Object.getPrototypeOf(InfiniteScrollOnContainer.prototype), 'getParentElement', this).call(this, el);
        }
      }, {
        key: 'render',
        value: function render() {
          return _get(InfiniteScrollOnContainer.prototype.__proto__ || Object.getPrototypeOf(InfiniteScrollOnContainer.prototype), 'render', this).call(this);
        }
      }]);
      return InfiniteScrollOnContainer;
    }(__WEBPACK_IMPORTED_MODULE_3_react_infinite_scroller___default.a);
    var masonryOptions = {
      transitionDuration: 500,
      isFitWidth: true
    };
    var imagesLoadedOptions = {};
    var clickedPreviewButton = function clickedPreviewButton(event, img, showPreview) {
      event.stopPropagation();
      showPreview(img);
    };
    var Thumb = function Thumb(_ref) {
      var img = _ref.img,
        selectImage = _ref.selectImage,
        source = _ref.source,
        showPreview = _ref.showPreview;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figure', {
        onClick: selectImage(source, img.id),
        key: img.id,
        className: 'thumb'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, !img.type || img.type === "Image" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', {
        src: img.thumbUrl,
        alt: img.title
      }) : img.type === "Video" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video, {
        url: img.src,
        type: img.type.mime,
        dimensions: img.dimensions
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        className: 'preview-btn'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["IconButton"], {
        icon: 'maximize',
        onClick: function onClick(_ref2) {
          var event = _ref2.event;
          clickedPreviewButton(event, img, showPreview);
        },
        accessibilityLabel: 'preview'
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('figcaption', null, img.title));
    };
    var Video = function Video(_ref3) {
      var url = _ref3.url,
        type = _ref3.type,
        dimensions = _ref3.dimensions;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', {
        autoPlay: false,
        preload: 'metadata',
        width: 240,
        controls: true
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', {
        src: url
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null));
    };
    var Gallery = function Gallery(_ref4) {
      var images = _ref4.images,
        selectImage = _ref4.selectImage,
        source = _ref4.source,
        showPreview = _ref4.showPreview,
        onScroll = _ref4.onScroll,
        hasMore = _ref4.hasMore;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfiniteScrollOnContainer, {
        pageStart: 0,
        loadMore: onScroll,
        hasMore: hasMore,
        loader: hasMore && images.length && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Spinner"], {
          show: true,
          accessibilityLabel: 'spinnner',
          key: 0
        }),
        initialLoad: false,
        threshold: 1000,
        container: 'pisco-app-container',
        useWindow: false,
        key: 'fixed-masonary-block'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_masonry_component___default.a, {
        id: 'pisco-masonry',
        options: masonryOptions // default {}
        ,
        disableImagesLoaded: false // default false
        ,
        updateOnEachImageLoad: false // default false and works only if disableImagesLoaded is false
        ,
        imagesLoadedOptions: imagesLoadedOptions // default {}
      }, images.map(function (img, idx) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Thumb, {
          img: img,
          source: source,
          selectImage: selectImage,
          showPreview: showPreview,
          key: idx
        });
      })));
    }; /* harmony default export */
    __webpack_exports__["a"] = Gallery;

    /***/
  }), ( /* 20 */
  /***/function (module, exports) {
    module.exports = require("react-masonry-component");

    /***/
  }), ( /* 21 */
  /***/function (module, exports) {
    module.exports = require("react-infinite-scroller");

    /***/
  }), ( /* 22 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_react_tagsinput__ = __webpack_require__(23);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_react_tagsinput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_tagsinput__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3_react_tagsinput_react_tagsinput_css__ = __webpack_require__(24);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3_react_tagsinput_react_tagsinput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_tagsinput_react_tagsinput_css__);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var orientations = {
      portrait: 'PORTRAIT',
      landscape: 'LANDSCAPE'
    };
    var reducer = {
      getInitialState: function getInitialState() {
        return {
          imageOrientation: orientations.portrait
        };
      }
    };
    var ModalFooter = function ModalFooter(_ref) {
      var save = _ref.save,
        hideModal = _ref.hideModal,
        loading = _ref.loading,
        saveDisabled = _ref.saveDisabled;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        justifyContent: 'end',
        display: 'flex',
        direction: 'row',
        marginLeft: -1,
        marginRight: -1
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        paddingX: 1
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Button"], {
        text: 'Cancel',
        onClick: hideModal,
        inline: true
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        paddingX: 1
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Button"], {
        color: 'red',
        text: 'Save',
        onClick: save,
        disabled: saveDisabled,
        inline: true
      })), loading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Spinner"], {
        show: loading,
        accessibilityLabel: 'detecting tags'
      }));
    };
    var ImagePreview = function ImagePreview(_ref2) {
      var img = _ref2.img;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2
      }, img && img.src && (!img.type || img.type === "Image") ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Image"], {
        src: img.previewUrl,
        alt: img.title,
        color: 'gray',
        naturalHeight: img.dimensions.height,
        naturalWidth: img.dimensions.width
      }) : img && img.src && img.type === "Video" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video, {
        url: img.src,
        type: img.type.mime,
        dimensions: img.dimensions
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Icon"], {
        icon: 'camera',
        accessibilityLabel: 'Image',
        color: 'darkGray',
        size: 25
      }));
    };
    var Video = function Video(_ref3) {
      var url = _ref3.url,
        type = _ref3.type,
        dimensions = _ref3.dimensions;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
        style: {
          overflow: 'hidden'
        }
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video', {
        autoPlay: false,
        height: 300,
        controls: true
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source', {
        src: url
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null));
    };
    var ModalBody = function ModalBody(_ref4) {
      var img = _ref4.img,
        updateSelectedImage = _ref4.updateSelectedImage,
        isLoadingTags = _ref4.isLoadingTags;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        paddingY: 6,
        paddingX: 4,
        display: 'flex'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 4
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Label"], {
        htmlFor: 'title'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Text"], {
        align: 'left',
        bold: true
      }, 'Title'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 8
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["TextField"], {
        id: 'title',
        value: img.title,
        onChange: function onChange(_ref5) {
          var value = _ref5.value;
          updateSelectedImage({
            title: value
          });
        },
        errorMessage: !img.title ? 'Field Cannot Be Empty' : null,
        idealErrorDirection: 'up'
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        paddingY: 6,
        paddingX: 4,
        display: 'flex'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 4
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Label"], {
        htmlFor: 'caption'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Text"], {
        align: 'left',
        bold: true
      }, 'Caption'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 8
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["TextArea"], {
        id: 'caption',
        value: img.caption,
        onChange: function onChange(_ref6) {
          var value = _ref6.value;
          updateSelectedImage({
            caption: value
          });
        },
        errorMessage: !img.caption ? 'Field Cannot Be Empty' : null,
        idealErrorDirection: 'up'
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        paddingY: 2,
        paddingX: 4,
        display: 'flex'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 4
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Label"], {
        htmlFor: 'tags'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Text"], {
        align: 'left',
        bold: true
      }, 'Tags'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 8
      }, isLoadingTags ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Spinner"], {
        show: true,
        accessibilityLabel: 'Loading...'
      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_tagsinput___default.a, {
        id: 'tags',
        value: img.tags,
        onChange: function onChange(tags) {
          updateSelectedImage({
            tags: tags
          });
        }
      }))));
    };
    var PortraitModal = function PortraitModal(_ref7) {
      var img = _ref7.img,
        hideModal = _ref7.hideModal,
        save = _ref7.save,
        updateSelectedImage = _ref7.updateSelectedImage,
        saveDisabled = _ref7.saveDisabled,
        loading = _ref7.loading,
        isLoadingTags = _ref7.isLoadingTags;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Modal"], {
        accessibilityCloseLabel: 'close',
        accessibilityModalLabel: 'Save Image/Video',
        heading: 'Save Image/Video',
        onDismiss: hideModal,
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalFooter, {
          hideModal: hideModal,
          save: save,
          loading: loading,
          saveDisabled: saveDisabled
        }),
        size: 'md'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImagePreview, {
        img: img
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        display: 'flex',
        direction: 'row',
        position: 'relative'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 12
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalBody, {
        img: img,
        updateSelectedImage: updateSelectedImage,
        isLoadingTags: isLoadingTags
      }))));
    };
    var LandscapeModal = function LandscapeModal(_ref8) {
      var img = _ref8.img,
        hideModal = _ref8.hideModal,
        save = _ref8.save,
        updateSelectedImage = _ref8.updateSelectedImage,
        saveDisabled = _ref8.saveDisabled,
        loading = _ref8.loading,
        isLoadingTags = _ref8.isLoadingTags;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Modal"], {
        accessibilityCloseLabel: 'close',
        accessibilityModalLabel: 'Save Image/Video',
        heading: 'Save Image/Video',
        onDismiss: hideModal,
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalFooter, {
          hideModal: hideModal,
          save: save,
          loading: loading,
          saveDisabled: saveDisabled
        }),
        size: 'lg'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
        display: 'flex',
        direction: 'row',
        position: 'relative'
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 8
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalBody, {
        img: img,
        updateSelectedImage: updateSelectedImage,
        isLoadingTags: isLoadingTags
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Column"], {
        span: 4
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImagePreview, {
        img: img
      }))));
    };
    var Dialog = function (_React$Component) {
      _inherits(Dialog, _React$Component);
      function Dialog() {
        _classCallCheck(this, Dialog);
        var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));
        _this.state = reducer.getInitialState();
        return _this;
      }
      _createClass(Dialog, [{
        key: 'render',
        value: function render() {
          var disabled = this.props.loading || !this.props.img.title || !this.props.img.caption || this.props.img.tags.length < 1;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, this.props.img && this.props.img.src &&
          // if img and img dimensions exist
          this.props.img.dimensions.width > this.props.img.dimensions.height ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PortraitModal // portrait modal previews landscape images
          , {
            img: this.props.img,
            updateSelectedImage: this.props.updateSelectedImage,
            save: this.props.save,
            hideModal: this.props.hideModal,
            loading: this.props.loading,
            isLoadingTags: this.props.isLoadingTags,
            saveDisabled: disabled
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LandscapeModal // landscape modal previews portrait images
          , {
            img: this.props.img,
            updateSelectedImage: this.props.updateSelectedImage,
            save: this.props.save,
            hideModal: this.props.hideModal,
            loading: this.props.loading,
            isLoadingTags: this.props.isLoadingTags,
            saveDisabled: disabled
          }));
        }
      }]);
      return Dialog;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); /* harmony default export */
    __webpack_exports__["a"] = Dialog;

    /***/
  }), ( /* 23 */
  /***/function (module, exports) {
    module.exports = require("react-tagsinput");

    /***/
  }), ( /* 24 */
  /***/function (module, exports) {

    // removed by extract-text-webpack-plugin

    /***/}), ( /* 25 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(3);
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }
      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }
    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }
      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    var ModalFooter = function (_React$Component) {
      _inherits(ModalFooter, _React$Component);
      function ModalFooter(props) {
        _classCallCheck(this, ModalFooter);
        var _this = _possibleConstructorReturn(this, (ModalFooter.__proto__ || Object.getPrototypeOf(ModalFooter)).call(this, props));
        _this.state = {
          imageHasLoaded: false,
          articlesWithAsset: []
        };
        return _this;
      }
      _createClass(ModalFooter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;
          this.props.fetchAssetArticles(this.props.img.uuid).then(function (response) {
            _this2.setState({
              articlesWithAsset: response.result || []
            });
          });
          if (this.props.img.cdn) {
            if (this.props.img.type === "Video") this.setState({
              imageHasLoaded: true
            });
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["e" /* hasImageLoaded */])(this.props.img.cdn).then(function () {
              _this2.setState({
                imageHasLoaded: true
              });
            }).catch(function (err) {
              console.error(err);
            });
          } else {
            throw Error('Image CDN URL not present');
          }
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            marginBottom: 3
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Text"], {
            align: 'center',
            size: 'md',
            bold: true
          }, 'Articles using this Asset')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            overflow: 'auto',
            height: 200
          }, this.state.articlesWithAsset.length ? this.state.articlesWithAsset.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {
              key: index
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
              marginTop: 2,
              marginBottom: 2
            }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', {
              target: '_blank',
              href: item.url
            }, item.title)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null));
          }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            alignContent: 'center',
            margin: 12
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Text"], {
            align: 'center',
            color: 'eggplant'
          }, 'No Related Articles'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            justifyContent: 'between',
            display: 'flex',
            direction: 'row',
            marginTop: 2
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Divider"], null), this.props.mode === 'repo' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            column: 6,
            paddingX: 1
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Button"], {
            text: 'Delete',
            onClick: function onClick() {
              _this3.props.deleteMedia(_this3.props.img.uuid);
            },
            color: 'red'
          })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            column: 6,
            paddingX: 1
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Button"], {
            text: 'Download',
            onClick: this.props.downloadImage,
            color: 'gray'
          }))), this.props.mode === 'embed' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Box"], {
            column: 12,
            paddingX: 1
          }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Button"], {
            color: 'blue',
            text: this.state.imageHasLoaded ? "Embed" : "Image is loading...",
            onClick: function onClick() {
              _this3.props.embedImage(_this3.props.img);
            },
            disabled: !this.state.imageHasLoaded
          }))));
        }
      }]);
      return ModalFooter;
    }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component); /* harmony default export */
    __webpack_exports__["a"] = function (_ref) {
      var hideModal = _ref.hideModal,
        downloadImage = _ref.downloadImage,
        embedImage = _ref.embedImage,
        img = _ref.img,
        fetchAssetArticles = _ref.fetchAssetArticles,
        deleteMedia = _ref.deleteMedia,
        mode = _ref.mode;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_gestalt__["Modal"], {
        role: 'dialog',
        accessibilityCloseLabel: 'close',
        accessibilityModalLabel: 'Media Information',
        heading: 'Media Information',
        onDismiss: hideModal,
        footer: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalFooter, {
          downloadImage: downloadImage,
          embedImage: embedImage,
          mode: mode,
          img: img,
          fetchAssetArticles: fetchAssetArticles,
          deleteMedia: deleteMedia
        }),
        size: 'md'
      });
    };

    /***/
  }), ( /* 26 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_burger_menu__ = __webpack_require__(27);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_react_burger_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_burger_menu__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_gestalt__ = __webpack_require__(2);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2_gestalt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gestalt__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3__configs__ = __webpack_require__(0);
    var sortByOptions = Object.keys(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SORTING_METHODS).map(function (method) {
      return {
        value: method,
        label: __WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SORTING_METHODS[method]
      };
    });
    var Settings = function Settings(props) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_burger_menu__["push"], {
        id: 'pisco-settings',
        pageWrapId: 'pisco-app-wrapper',
        outerContainerId: 'pisco-app-container',
        isOpen: props.isOpen,
        onStateChange: props.onStateChange
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Box"], {
        alignItems: 'center',
        justifyContent: 'between',
        direction: 'row',
        display: 'flex',
        paddingY: 3
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Text"], {
        color: 'white',
        size: 'md'
      }, 'Search Getty'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Switch"], {
        id: 'searchGetty',
        onChange: function onChange() {
          props.toggleSearchOn(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty);
        },
        switched: props.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.getty],
        disabled: props.disableGetty
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Box"], {
        alignItems: 'center',
        justifyContent: 'between',
        direction: 'row',
        display: 'flex',
        paddingY: 3
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Text"], {
        color: 'white',
        size: 'md'
      }, 'Search Elastic'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Switch"], {
        id: 'searchElastic',
        switched: props.searchOnSettings[__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic],
        onChange: function onChange() {
          props.toggleSearchOn(__WEBPACK_IMPORTED_MODULE_3__configs__["a" /* default */].SEARCH_SOURCE.elastic);
        }
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Box"], {
        alignItems: 'center',
        justifyContent: 'between',
        direction: 'row',
        display: 'flex',
        paddingY: 3
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Column"], {
        span: 4
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Text"], {
        color: 'white',
        size: 'md'
      }, 'Sort By:')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["Column"], {
        span: 8
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_gestalt__["SelectList"], {
        id: 'sort-by-selector',
        placeholder: 'Sort results by...',
        options: sortByOptions,
        value: props.sortBy,
        onChange: function onChange(_ref) {
          var value = _ref.value;
          props.onSortingChange(value);
        }
      }))));
    }; /* harmony default export */
    __webpack_exports__["a"] = Settings;

    /***/
  }), ( /* 27 */
  /***/function (module, exports) {
    module.exports = require("react-burger-menu");

    /***/
  }), ( /* 28 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(29);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_superagent_prefix__ = __webpack_require__(30);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1_superagent_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent_prefix__);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_2__configs__ = __webpack_require__(0);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_3__parseElasticResult__ = __webpack_require__(31);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_4__parseGettyResult__ = __webpack_require__(32);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_5__createFormData__ = __webpack_require__(33);
    /* harmony default export */
    __webpack_exports__["a"] = function () {
      var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__configs__["a" /* default */].ENDPOINT;
      var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var prefix = __WEBPACK_IMPORTED_MODULE_1_superagent_prefix___default()(endpoint + '/pisco');
      var request = __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.agent().use(prefix).set("authorization", headers.authorization).withCredentials();
      var APIS = {
        //TODO: set domain
        media: {
          details: function details(injectedQuery, id) {
            return request.get(endpoint + '/article/' + injectedQuery.domainId + '/pisco').query({
              id: id
            }).then(function (response) {
              return response;
            });
          },
          delete: function _delete(uuid) {
            return request.delete('/delete').send({
              uuid: uuid
            });
          }
        },
        search: {
          elastic: function elastic(domain) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Image';
            var searchQry = arguments[2];
            var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var sort = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'newest';
            var injectedQuery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
            return request.get('/elastic/fetch').query(Object.assign({
              q: searchQry,
              from: page,
              // STORE.elasticImageById.length,
              sort: sort,
              domain: domain,
              type: type
            }, injectedQuery)).then(function (response) {
              return response.body;
            }).then(function (images) {
              return images.map(function (img) {
                return Object.assign({}, img.source, {
                  esIndex: img.index,
                  esScore: img.score,
                  id: img.source.uuid
                });
              });
            }).then(__WEBPACK_IMPORTED_MODULE_3__parseElasticResult__["a" /* default */]);
          },
          getty: function getty(searchQry) {
            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'newest';
            var injectedQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            return request.get('/getty/fetch').query(Object.assign({
              q: searchQry,
              page: page,
              sort: sort
            }, injectedQuery)).then(function (response) {
              return response.body;
            }).then(__WEBPACK_IMPORTED_MODULE_4__parseGettyResult__["a" /* default */]);
          }
        },
        save: {
          preSave: function preSave(file) {
            var injectedQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return request.post('/preSave').query(Object.assign({}, injectedQuery)).send(Object(__WEBPACK_IMPORTED_MODULE_5__createFormData__["a" /* default */])(file)).then(function (response) {
              return response.body;
            });
          },
          local: function local(domain, file, data) {
            var injectedQuery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            return request.post('/local/upload').query(Object.assign({}, injectedQuery)).send(Object(__WEBPACK_IMPORTED_MODULE_5__createFormData__["a" /* default */])(file, Object.assign({}, data, {
              domain: domain
            }))).then(function (response) {
              return response.body;
            });
          },
          getty: function getty(domain, imageData) {
            var injectedQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return request.post('/getty/upload/' + imageData.id).query(Object.assign({}, injectedQuery)).send(Object.assign({}, imageData, {
              domain: domain
            })).then(function (response) {
              return [response.body];
            }).then(__WEBPACK_IMPORTED_MODULE_3__parseElasticResult__["a" /* default */]).then(function (parsedResult) {
              return parsedResult[0];
            });
          }
        },
        getImageTags: function getImageTags(url, injectedQuery) {
          return request.get('/tags').query(Object.assign({
            url: encodeURIComponent(url)
          }, injectedQuery)).then(function (response) {
            return response.body;
          });
        }
      };
      return APIS;
    };
    ;

    /***/
  }), ( /* 29 */
  /***/function (module, exports) {
    module.exports = require("superagent");

    /***/
  }), ( /* 30 */
  /***/function (module, exports) {
    module.exports = require("superagent-prefix");

    /***/
  }), ( /* 31 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__configs__ = __webpack_require__(0);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1__utils_helpers__ = __webpack_require__(3);
    /* harmony default export */
    __webpack_exports__["a"] = function (images) {
      return images.map(function (img) {
        var cdnUrl = img.cdn || Object(__WEBPACK_IMPORTED_MODULE_1__utils_helpers__["a" /* getCDNURL */])(img.s3Url);
        return Object.assign({}, img, {
          src: cdnUrl,
          thumbUrl: cdnUrl,
          previewUrl: cdnUrl,
          cdn: cdnUrl,
          tags: img.labels,
          imageSource: __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].IMAGE_SOURCE[img.esIndex],
          searchSource: __WEBPACK_IMPORTED_MODULE_0__configs__["a" /* default */].SEARCH_SOURCE.elastic
        });
      });
    };

    /***/
  }), ( /* 32 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(3);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1__configs__ = __webpack_require__(0);
    /* harmony default export */
    __webpack_exports__["a"] = function (images) {
      images = images.map(function (img) {
        return Object.assign({}, img, {
          src: (img.display_sizes.find(function (size) {
            return size.name === 'comp';
          }) || {}).uri,
          thumbUrl: (img.display_sizes.find(function (size) {
            return size.name === 'thumb';
          }) || {}).uri,
          previewUrl: (img.display_sizes.find(function (size) {
            return size.name === 'preview';
          }) || {}).uri,
          // dimensions: img.display_sizes.find(size => size.name === 'thumb').uri.match(/&s=((\d)+x(\d)+)&/)[1].split('x').map(d => +d)
          tags: [],
          originalGettyData: {
            title: img.title,
            caption: img.caption
          },
          imageSource: __WEBPACK_IMPORTED_MODULE_1__configs__["a" /* default */].IMAGE_SOURCE.getty,
          searchSource: __WEBPACK_IMPORTED_MODULE_1__configs__["a" /* default */].SEARCH_SOURCE.getty
        });
      });
      var imagesDimensions = images.map(function (img) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getImageDimensionsPromise */])(img.thumbUrl);
      });
      return Promise.all(imagesDimensions).then(function (dimensions) {
        return dimensions.map(function (dimension, idx) {
          return Object.assign({}, images[idx], {
            dimensions: dimension
          });
        });
      });
    };

    /***/
  }), ( /* 33 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }; /* harmony default export */
    __webpack_exports__["a"] = function (file, data) {
      var formData = new FormData();
      formData.append("file", file, file.name); // add assoc key values, this will be posts values
      if (data && (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object') {
        for (var key in data) {
          if (data[key]) {
            formData.append(key, data[key]);
          }
        }
      }
      return formData;
    };

    /***/
  }), ( /* 34 */
  /***/function (module, __webpack_exports__, __webpack_require__) {
    "use strict";

    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_0__helpers__ = __webpack_require__(3);
    /* harmony import */
    var __WEBPACK_IMPORTED_MODULE_1__configs__ = __webpack_require__(0);
    /* harmony default export */
    __webpack_exports__["a"] = function (file, requestedFile) {
      var image = {
        filename: file.name,
        title: file.name.split('.').slice(0, file.name.split('.').length - 1).join('.'),
        tags: [],
        imageSource: __WEBPACK_IMPORTED_MODULE_1__configs__["a" /* default */].IMAGE_SOURCE.local,
        type: Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["g" /* isVideo */])(file) ? 'Video' : Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["f" /* isImage */])(file) ? 'Image' : 'File'
      };
      return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["b" /* getImageBinarySrcPromise */])(file).then(function (binaryImageSrc) {
        return Object.assign({}, image, {
          src: binaryImageSrc,
          thumbUrl: binaryImageSrc,
          previewUrl: binaryImageSrc
        });
      }).then(function (image) {
        if (image.type === "Video" && (requestedFile === "Video" || requestedFile === "Both")) return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["d" /* getVideoDimensionsPromise */])(image.thumbUrl).then(function (dimensions) {
          return Object.assign({}, image, {
            dimensions: dimensions
          });
        });else if (image.type === "Image" && (requestedFile === "Image" || requestedFile === "Both")) return Object(__WEBPACK_IMPORTED_MODULE_0__helpers__["c" /* getImageDimensionsPromise */])(image.thumbUrl).then(function (dimensions) {
          return Object.assign({}, image, {
            dimensions: dimensions
          });
        });else return Promise.reject("Media Not Supported");
      }).catch(function (err) {
        alert(err);
        console.log(err);
        return Promise.reject({
          width: -1,
          height: -1
        });
      });
    };

    /***/
  }), ( /* 35 */
  /***/function (module, exports) {
    module.exports = require("lodash");

    /***/
  }
  /******/)]);
});